import { api } from '@/api'
import type { SessionUser } from '../types'

export function fetchUserInfo(): Promise<SessionUser> {
  return api.get<SessionUser>('/userinfo')
}

export function postLogout(): Promise<unknown> {
  // Auth routes live outside the /bff base.
  return api.post('/auth/logout', { baseURL: '' })
}
